/* eslint-disable ember/no-component-lifecycle-hooks */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ModalDialog from 'ember-modal-dialog/components/modal-dialog';

const BODY_CLASSES = ['overflow-hidden'];
const FIXED_BODY_CLASSES = ['fixed', 'w-full'];
// eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
export default ModalDialog.extend({
  didInsertElement() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this._super(...arguments);
    const hasScrollBar = window.innerWidth > document.body.clientWidth;
    if (hasScrollBar) {
      document.body.style.marginRight = `${window.innerWidth - document.body.clientWidth}px`;
    }
    document.body.classList.add(...BODY_CLASSES);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.fixedBody) document.body.classList.add(...FIXED_BODY_CLASSES);
  },
  willDestroyElement() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this._super(...arguments);
    document.body.classList.remove(...BODY_CLASSES);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.fixedBody) document.body.classList.remove(...FIXED_BODY_CLASSES);
    document.body.style.marginRight = '';
  },
});
